import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import envConfig from "../config.json";
import { Typography, Input, Row, Col, Spin, Button } from "antd";
import axios from "axios";
import ListContent from "../components/ListContent";
import AssetUpload from "../components/AssetUpload";
import { searchStyle } from "../StyleObj";
import PlantSelection from "./PlantSelection";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { useTheme } from "./ThemeContext";
const { Search } = Input;
const LOGINSUCCESS = "LoginSuccess";

/**
 * component used to handle AOT  model
 * @returns
 */
const AotModel = () => {
  const { instance, accounts } = useMsal();
  const { Title } = Typography;
  const [sas, setSas] = useState("");
  const [models, setModels] = useState([]);
  const [showProgress, setShowProgress] = useState(false);
  const [contentLength, setContentLength] = useState(0);
  const [cassetId, setCassetId] = useState("");
  const [updatedAt, setUpdatedAt] = useState("");
  const [loadMoreContent, setLoadMoreContent] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [plantData, setPlantData] = useState([]);
  const [selectedPlant, setSelectedPlant] = useState("");
  const [selectedPlantName, setSelectedPlantName] = useState("");
  const msalToken = localStorage.getItem("msal.accesstoken");
  const { theme } = useTheme();

  /**
   * This arrow function used to filter the models for decouple(AOT) application type
   */
  const filterModels = (value, e) => {
    setShowProgress(true);
    setSearchText(value);
    setCassetId("");
    models.length = 0;
    setModels([]);
    setContentLength(0);
    if (value) {
      fetchModelsLoadMore(value, true);
    } else {
      fetchModels();
    }
  };

  /**
   * This arrow function used to fetch the models for decouple(AOT) application type
   */
  const fetchModels = () => {
    setModels([]);
    setShowProgress(true);
    const getConfig = {
      headers: { Authorization: `Bearer ${msalToken}` },
    };
    axios
      .get(
        `${envConfig.aotmwapi}/api/3d-cms/content?plantId=${selectedPlant}`,
        getConfig
      )
      .then((res) => {
        setModels(res.data.data);
        setSas(res.data.sasToken);
        setContentLength(res.data.totalAssetsCount);
        localStorage.setItem("sasToken", res.data.sasToken);
        setShowProgress(false);
        if (res.data.lastRead.assetId != null) {
          setLoadMoreContent(true);
          setCassetId(res.data.lastRead.assetId);
          setUpdatedAt(res.data.lastRead.updatedAt);
        } else {
          setLoadMoreContent(false);
        }
      })
      .catch((err) => {
        console.error( "error in fetchModels API" );
        if (err.response.status === 401) {
          localStorage.removeItem("checkRole");
          const logoutRequest = {
            postLogoutRedirectUri: envConfig.redirectUri,
          };
          instance.logoutRedirect(logoutRequest);
        }
      }); // debug
  };
  /**
   * This arrow function used to fetch the models on loadmore or filter icon click for decouple(AOT) application type
   */
  const buildUrl = (title, isInitialSearch) => {
    const searchedText = searchText || (title?.length ? title : "");
    if (cassetId && !isInitialSearch) {
      if (!searchedText?.length) {
        return `${envConfig.aotmwapi}/api/3d-cms/content?lastReadAssetId=${cassetId}&lastReadUpdatedAt=${updatedAt}&plantId=${selectedPlant}`;
      } else {
        return `${envConfig.aotmwapi}/api/3d-cms/content?lastReadAssetId=${cassetId}&lastReadUpdatedAt=${updatedAt}&searchText=${searchedText}&plantId=${selectedPlant}`;
      }
    } else if (searchedText?.length) {
      return `${envConfig.aotmwapi}/api/3d-cms/content?searchText=${searchedText}&plantId=${selectedPlant}`;
    } else {
      return `${envConfig.aotmwapi}/api/3d-cms/content&plantId=${selectedPlant}`;
    }
  };

  const handleSuccess = (response) => {
    setSas(response.data.sasToken);
    localStorage.setItem("sasToken", response.data.sasToken);
    setContentLength(response.data.totalAssetsCount);
    if (!models.length) {
      setModels(response.data.data);
    } else {
      setModels([...models, ...response.data.data]);
    }
    if (response.data.lastRead.assetId) {
      setLoadMoreContent(true);
      setCassetId(response.data.lastRead.assetId);
      setUpdatedAt(response.data.lastRead.updatedAt);
    } else {
      setLoadMoreContent(false);
    }
    setShowProgress(false);
  };

  const handleError = (err) => {
    if (err.response.status === 401) {
      localStorage.removeItem("checkRole");
      const logoutRequest = {
        postLogoutRedirectUri: envConfig.redirectUri,
      };
      instance.logoutRedirect(logoutRequest);
    }
  };

  const fetchModelsLoadMore = (title, isInitialSearch = false) => {
    const url = buildUrl(title, isInitialSearch);
    const getConfig = {
      headers: { Authorization: `Bearer ${msalToken}` },
    };
    axios.get(url, getConfig).then(handleSuccess).catch(handleError);
  };
  /**
 * method used to extract number from the input plantlist
 * @param plantname
 * @returns number inside the plant list
 */
  const extractNumber = (name) => {
    const match = name.match(/(\d+)/);
    return match ? parseInt(match[0], 10) : -1;
  };
  const getPlant = () => {
    const msalToken = localStorage.getItem("msal.accesstoken");
    const config = {
      headers: {
        Authorization: `Bearer ${msalToken}`,
      },
    };
    axios
      .get(`${envConfig.aotmwapi}/api/oh-module/plantlist`, config)
      .then((response) => {
        let plantList = response.data.plantlist;
        plantList = plantList.sort((a, b) => {
          const nameA = a.PlantName.replace(/(\d+)/, '').trim();
          const nameB = b.PlantName.replace(/(\d+)/, '').trim();
          
          if (nameA === nameB) {
            return extractNumber(a.PlantName) - extractNumber(b.PlantName);
          }
          
          return nameA.localeCompare(nameB);
        });
       
        setPlantData(plantList);
        setSelectedPlant(plantList[0].PlantId);
        setSelectedPlantName(plantList[0].PlantName);
        setShowProgress(false);
      })
      .catch((error) => {
        setShowProgress(false);
        const status = sessionStorage.getItem("login-inprogress");
        if (error.response.status === 401 && (status && status == 0)) {
          localStorage.removeItem("checkRole");
          const logoutRequest = {
            postLogoutRedirectUri: envConfig.redirectUri,
          };
          instance.logoutRedirect(logoutRequest);
        }
        console.error("error in GetPlant API");
      });
  };
  const handlePlantId = async (plantId) => {
    setSelectedPlant(plantId);
    const selectedPlantArr = await Promise.all(
      plantData.filter((x) => x.PlantId === plantId)
    );
    setSelectedPlantName(selectedPlantArr[0].PlantName);
  };
  /**
   * checkAccessToken - This async function checks the validity of the access token
   * @returns {Promise<void>} - A promise that resolves when the token check is complete.
   * @throws {Error} - Throws an error if the token cannot be acquired silently.
   */
  const checkAccessToken = async () => {
    const request = {
      scopes: [`${envConfig.clientId}/access_as_user`],
      account: accounts[0],
    };
    const response = await instance.acquireTokenSilent(request);
    const accessToken = response.accessToken;
    if (accessToken) {
      localStorage.setItem("msal.accesstoken", accessToken);
      getPlant();
    }
  };
  /**
   * React hook to handle side effect
   */
  useEffect(() => {
    setShowProgress(true);
    if (msalToken) {
      checkAccessToken();
    }
    const handleLoginSuccess = () => getPlant();
    window.addEventListener(LOGINSUCCESS, handleLoginSuccess);
    return () => {
      window.removeEventListener(LOGINSUCCESS, handleLoginSuccess);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedPlant) {
      setSearchText('');
      fetchModels();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPlant]);

  return (
    <div id={`TwinBuilder-3d-Files-containerFixed-${theme}`}>
      <Row className="paddingRow">
        <Col span={8}>
          <div className="divAlignLeft">
            <Title className={`TwinBuilder-text-color-${theme}`}>Model</Title>
          </div>
        </Col>
        <Col span={16}>
          <div className="assetUploadTop">
            <PlantSelection
              plantData={plantData}
              selectedPlant={selectedPlant}
              handlePlantId={handlePlantId}
            />
            <AssetUpload
              sas={sas}
              fetchModels={fetchModels}
              selectedPlant={selectedPlant}
              plantName={selectedPlantName}
              setSearchText = {setSearchText}
            />
          </div>

          {/* <div className="assetUploadTop">
              <AssetUpload sas={sas} fetchModels={fetchModels} />
            </div> */}
        </Col>
      </Row>
      <Row className="paddingRow">
        <Col span={12}>
          <div className="divAlignLeft">
            <p className={`TwinBuilder-text-color-${theme}`}>{contentLength} Models</p>
          </div>
        </Col>
        <Col span={12}>
          <div className="divAlignRight">
            {/* <AssetUpload sas={sas} fetchModels={fetchModels} /> */}
            <Search
            className={`TwinBuilder-text-color-${theme}`}
              placeholder="Search Model"
              value={searchText} 
              allowClear
               onChange={(e) => {
                const value = e.target.value;
                setSearchText(value);
                if (value === '') {
                  filterModels('', e); // Call filter when input is cleared
                }
              }}
              bordered={false}
              onSearch={(value, event) => filterModels(value, event)}
              style={searchStyle(theme)}
            />
          </div>
        </Col>
      </Row>
      <br />
      <div>
        <Spin spinning={showProgress}>
          <div id="content-scroll" className="listContainer">
            {models.length > 0 ? (
              <ListContent
                models={models}
                fetchModels={fetchModels}
                sas={sas}
                page="aot"
                selectedPlant={selectedPlant}
                plantName={selectedPlantName}
              />
            ) : (
              <Row className="paddingRow">
                <div className={`empty_container-${theme}`}>
                  <div>
                    <ExclamationCircleFilled className={`icon_noData-${theme}`} style={{color:"#FF4F59"}}/>
                  </div>
                  {searchText.trim() !== '' ? (
            <>
              <div>NO MATCHING MODELS FOUND</div>
              <div>Try checking your spelling or search criteria</div>
            </>
          ) : (
            <>
              <div>NO MODELS HAVE BEEN LISTED</div>
              <div>Select a Plant to see the Models</div>
            </>
          )}
                </div>
              </Row>
            )}
            {loadMoreContent ? (
              <div className="divAlignCenter">
                <Button className={`builderButton-${theme}`} onClick={fetchModelsLoadMore}>
                  Load More
                </Button>
              </div>
            ) : null}
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default AotModel;
